document.addEventListener("DOMContentLoaded", function () {
  const addon = document.getElementById("js-addon");
  const price = document.getElementById("product-price");
  const form = document.getElementById("product-form");

  if (!addon || !price || !form) {
    console.warn("Addon, price, or form missing");
    return;
  }

  const basePrice = Number(price.dataset.base);
  const addonPrice = Number(addon.dataset.price);

  function formatMoney(cents) {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD"
    }).format(cents / 100);
  }

  addon.addEventListener("change", function () {
    let total = basePrice;

    if (this.checked) {
      total += addonPrice;
    }

    price.innerHTML = formatMoney(total) + " AUD";
  });

  form.addEventListener("submit", function (e) {
    if (!addon.checked) return;

    e.preventDefault();

    const mainVariantId = Number(
      form.querySelector('input[name="id"]').value
    );

    const addonVariantId = Number(
      addon.dataset.id
    );

    console.log("Adding to cart:", {
      mainVariantId,
      addonVariantId
    });

    if (!mainVariantId || !addonVariantId) {
      console.error("Missing variant ID");
      return;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: mainVariantId,
            quantity: 1
          },
          {
            id: addonVariantId,
            quantity: 1
          }
        ]
      })
    })
      .then(async (response) => {
        const data = await response.json();

        if (!response.ok) {
          console.error("Cart error:", data);
          throw new Error(data.description || "Cart add failed");
        }

        return data;
      })
      .then(() => {
        window.location.href = "/cart";
      })
      .catch((error) => {
        console.error("Failed to add products:", error);
      });
  });
});

// ---------- SLIDER LOGIC ----------

const slides = document.querySelectorAll(".hero-slide");
const dots = document.querySelectorAll(".hero-dot");
const slider = document.querySelector(".hero-slider");

let current = 0;
let isAnimating = false;

// Ensure a clean initial state:
// - first slide centered
// - all others off to the right
function initSlider() {
  slides.forEach((slide, i) => {
    slide.style.transition = "transform 0.35s ease, visibility 0.35s ease";
    slide.style.visibility = "visible";
    slide.style.opacity = "1";

    if (i === 0) {
      slide.style.transform = "translateX(0)";
      slide.style.zIndex = "2";
    } else {
      slide.style.transform = "translateX(100%)";
      slide.style.zIndex = "1";
    }
  });
}

initSlider();

function showSlide(index, direction) {
  if (slides.length <= 1 || isAnimating) return;

  const nextIndex = ((index % slides.length) + slides.length) % slides.length;
  if (nextIndex === current) return;

  isAnimating = true;

  if (direction === undefined) {
    direction = nextIndex > current ? 1 : -1;
    if (nextIndex === 0 && current === slides.length - 1) direction = 1;
    if (nextIndex === slides.length - 1 && current === 0) direction = -1;
  }

  const prevSlide = slides[current];
  const nextSlide = slides[nextIndex];
  const startX = direction > 0 ? "translateX(100%)" : "translateX(-100%)";
  const exitX  = direction > 0 ? "translateX(-100%)" : "translateX(100%)";

  // Park all other slides out of the way (doesn't need a transition)
  slides.forEach((s, i) => {
    if (i !== current && i !== nextIndex) {
      s.style.transition = "none";
      s.style.transform = "translateX(100%)";
      s.style.zIndex = "1";
    }
  });

  prevSlide.style.zIndex = "2";

  // --- Snap the incoming slide to its start position WITHOUT animating ---
  nextSlide.style.transition = "none";
  nextSlide.style.transform = startX;
  nextSlide.style.zIndex = "3";
  nextSlide.style.visibility = "visible";
  nextSlide.style.opacity = "1";

  // Force the browser to apply the snap before we re-enable transitions
  nextSlide.offsetHeight;

  // --- Re-enable transitions, then animate to final positions ---
  nextSlide.style.transition = "transform 0.35s ease, visibility 0.35s ease";
  prevSlide.style.transition = "transform 0.35s ease, visibility 0.35s ease";

  prevSlide.style.transform = exitX;
  nextSlide.style.transform = "translateX(0)";

  dots.forEach((d, i) => d.classList.toggle("active", i === nextIndex));

  current = nextIndex;

  setTimeout(() => {
    isAnimating = false;
  }, 350);
}

// Arrow buttons
document.querySelector(".hero-arrow.next")
  .addEventListener("click", () => showSlide(current + 1, 1));

document.querySelector(".hero-arrow.prev")
  .addEventListener("click", () => showSlide(current - 1, -1));

// Dots
dots.forEach((dot, i) => {
  dot.addEventListener("click", () => {
    const direction = i > current ? 1 : -1;
    showSlide(i, direction);
  });
});

// Keyboard
document.addEventListener("keydown", (e) => {
  if (e.key === "ArrowRight") {
    showSlide(current + 1, 1);
  }
  if (e.key === "ArrowLeft") {
    showSlide(current - 1, -1);
  }
});

// Touch
let touchStartX = 0;
let touchStartY = 0;
let isHorizontalSwipe = false;

slider.addEventListener("touchstart", (e) => {
  touchStartX = e.touches[0].clientX;
  touchStartY = e.touches[0].clientY;
  isHorizontalSwipe = false;
}, { passive: true });


slider.addEventListener("touchmove", (e) => {
  const deltaX = e.touches[0].clientX - touchStartX;
  const deltaY = e.touches[0].clientY - touchStartY;

  // Detect horizontal intent
  if (Math.abs(deltaX) > Math.abs(deltaY)) {
    isHorizontalSwipe = true;
    e.preventDefault();
  }
}, { passive: false });


slider.addEventListener("touchend", (e) => {
  if (!isHorizontalSwipe) return;

  const distance = e.changedTouches[0].clientX - touchStartX;

  if (distance > 50) {
    showSlide(current - 1, -1);
  }

  if (distance < -50) {
    showSlide(current + 1, 1);
  }
});



// FAQ

const items = document.querySelectorAll('.faq-item');
items.forEach(item => {
  function toggle(){
    const isOpen = item.getAttribute('data-open') === 'true';

    // close all items first
    items.forEach(other => {
      other.setAttribute('data-open', 'false');
      other.setAttribute('aria-expanded', 'false');
    });

    // then open this one, unless it was already open (so clicking twice closes it)
    if(!isOpen){
      item.setAttribute('data-open', 'true');
      item.setAttribute('aria-expanded', 'true');
    }
  }
  item.addEventListener('click', toggle);
  item.addEventListener('keydown', (e) => {
    if(e.key === 'Enter' || e.key === ' '){
      e.preventDefault();
      toggle();
    }
  });
});




// -------------------------
// Product variants 
// -------------------------

function selectFirstAvailable(name) {
  const options = document.querySelectorAll(
    `input[name="${name}"]`
  );

  const firstAvailable = [...options].find(
    option => !option.disabled
  );

  if (firstAvailable) {
    firstAvailable.checked = true;

    firstAvailable.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }
}


// Select the first option in each series
selectFirstAvailable('switch-type');
selectFirstAvailable('switch-position');
selectFirstAvailable('switch-backlight');

const optionMatches = window.switchLightCompatibility;

console.log('Option matches:', optionMatches);

function updateBacklightOptions() {

  const selectedType = document.querySelector(
    'input[name="switch-type"]:checked'
  )?.value;

  if (!selectedType) return;

  const availableBacklights = optionMatches[selectedType] || [];

  document
    .querySelectorAll('input[name="switch-backlight"]')
    .forEach(input => {

      const isAvailable = availableBacklights.includes(input.value);

      input.disabled = !isAvailable;

      const option = input.closest('.product-option');

      if (option) {
        option.classList.toggle(
          'unavailable',
          !isAvailable
        );
      }
    });


  // If selected backlight is unavailable,
  // select the first available one

  const selectedBacklight = document.querySelector(
    'input[name="switch-backlight"]:checked'
  );

  if (selectedBacklight?.disabled) {

    const firstAvailable = document.querySelector(
      'input[name="switch-backlight"]:not(:disabled)'
    );

    if (firstAvailable) {
      firstAvailable.checked = true;

      firstAvailable.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }
  }
}


// Watch Switch Type
document
  .querySelectorAll('input[name="switch-type"]')
  .forEach(input => {
    input.addEventListener(
      'change',
      updateBacklightOptions
    );
  });


// Initial state
updateBacklightOptions();




// ------ Backgroup swatch colour -------//
const productOptionSelector = document.querySelector('.product-option-selector');

if (productOptionSelector) {
  const backlightOptions = productOptionSelector.querySelectorAll(
    'input[name="switch-backlight"]'
  );

  function updateActiveSwatchColour() {
    const selected = productOptionSelector.querySelector(
      'input[name="switch-backlight"]:checked'
    );

    if (!selected) return;

    const swatch = selected.nextElementSibling;

    if (!swatch) return;

    const colour = getComputedStyle(swatch)
      .getPropertyValue('--swatch-color')
      .trim();

    if (colour) {
      productOptionSelector.style.setProperty(
        '--swatch-color-active',
        colour
      );
    }
  }

  backlightOptions.forEach(input => {
    input.addEventListener('change', updateActiveSwatchColour);
  });

  updateActiveSwatchColour();
}